// HSL shade scales for each user-selectable primary palette.
// Values are space-separated "H S% L%" strings so they slot directly
// into hsl(var(--app-primary-NNN) / <alpha-value>) in tailwind.config.js.
// Defaults sourced from Tailwind's official colour scales.

export const PALETTES = {
  orange: {
    label_en: 'Orange',
    label_ar: 'برتقالي',
    shades: {
      50:  '33.3 100% 96.5%',
      100: '34.3 100% 91.8%',
      200: '32.1 97.7% 83.1%',
      300: '30.7 97.2% 72.4%',
      400: '27 96% 61%',
      500: '24.6 95% 53.1%',
      600: '20.5 90.2% 48.2%',
      700: '17.5 88.3% 40.4%',
      800: '15 79.1% 33.7%',
      900: '15.2 75.4% 27.8%',
      950: '13 81.3% 14.5%',
    },
  },
  red: {
    label_en: 'Red',
    label_ar: 'أحمر',
    shades: {
      50:  '0 85.7% 97.3%',
      100: '0 93.3% 94.1%',
      200: '0 96.3% 89.4%',
      300: '0 93.5% 81.8%',
      400: '0 90.6% 70.8%',
      500: '0 84.2% 60.2%',
      600: '0 72.2% 50.6%',
      700: '0 73.7% 41.8%',
      800: '0 70% 35.3%',
      900: '0 62.8% 30.6%',
      950: '0 74.7% 15.5%',
    },
  },
  blue: {
    label_en: 'Blue',
    label_ar: 'أزرق',
    shades: {
      50:  '213.8 100% 96.9%',
      100: '214.3 94.6% 92.7%',
      200: '213.3 96.9% 87.3%',
      300: '211.7 96.4% 78.4%',
      400: '213.1 93.9% 67.8%',
      500: '217.2 91.2% 59.8%',
      600: '221.2 83.2% 53.3%',
      700: '224.3 76.3% 48%',
      800: '225.9 70.7% 40.2%',
      900: '224.4 64.3% 32.9%',
      950: '226.2 55.3% 18.4%',
    },
  },
  green: {
    label_en: 'Green',
    label_ar: 'أخضر',
    shades: {
      50:  '138.5 76.5% 96.7%',
      100: '140.6 84.2% 92.5%',
      200: '141 78.9% 85.1%',
      300: '141.7 76.6% 73.1%',
      400: '141.9 69.2% 58%',
      500: '142.1 70.6% 45.3%',
      600: '142.1 76.2% 36.3%',
      700: '142.4 71.8% 29.2%',
      800: '142.8 64.2% 24.1%',
      900: '143.8 61.2% 20.2%',
      950: '144.9 80.4% 10%',
    },
  },
  purple: {
    label_en: 'Purple',
    label_ar: 'بنفسجي',
    shades: {
      50:  '270 100% 98%',
      100: '268.7 100% 95.5%',
      200: '268.6 100% 91.8%',
      300: '269.2 97.4% 85.1%',
      400: '270 95.2% 75.3%',
      500: '270.7 91% 65.1%',
      600: '271.5 81.3% 55.9%',
      700: '272.1 71.7% 47.1%',
      800: '272.9 67.2% 39.4%',
      900: '273.6 65.6% 32%',
      950: '273.5 86.9% 21%',
    },
  },
  pink: {
    label_en: 'Pink',
    label_ar: 'وردي',
    shades: {
      50:  '327.3 73.3% 97.1%',
      100: '325.7 77.8% 94.7%',
      200: '325.9 84.6% 89.8%',
      300: '327.4 87.1% 81.8%',
      400: '328.6 85.5% 70.2%',
      500: '330.4 81.2% 60.4%',
      600: '333.3 71.4% 50.6%',
      700: '335.1 77.6% 42%',
      800: '335.8 74.4% 35.3%',
      900: '335.9 69% 30.4%',
      950: '336.2 83.9% 17.1%',
    },
  },
  teal: {
    label_en: 'Teal',
    label_ar: 'تيركواز',
    shades: {
      50:  '166.2 76.5% 96.7%',
      100: '167.2 85.5% 89.2%',
      200: '168.4 83.8% 78.2%',
      300: '170.6 76.9% 64.3%',
      400: '172.5 66% 50.4%',
      500: '173.4 80.4% 40%',
      600: '174.7 83.9% 31.6%',
      700: '175.3 77.4% 26.1%',
      800: '176.1 69.4% 21.8%',
      900: '175.9 60.8% 19%',
      950: '178.6 84.3% 10%',
    },
  },
  amber: {
    label_en: 'Amber',
    label_ar: 'أصفر',
    shades: {
      50:  '48 100% 96.1%',
      100: '48 96.5% 88.8%',
      200: '48 96.6% 76.7%',
      300: '45.9 96.7% 64.5%',
      400: '43.3 96.4% 56.3%',
      500: '37.7 92.1% 50.2%',
      600: '32.1 94.6% 43.7%',
      700: '26 90.5% 37.1%',
      800: '22.7 82.5% 31.4%',
      900: '21.7 77.8% 26.5%',
      950: '20.9 91.7% 14.1%',
    },
  },
}

export const PALETTE_KEYS = Object.keys(PALETTES)
export const DEFAULT_PALETTE = 'blue'

// Write a palette's 11 shades into CSS variables on :root so every
// `bg-app-primary-500`, `text-app-primary-300/60`, etc. consumer
// picks up the new colour without a re-render.
export function applyPalette(name) {
  const palette = PALETTES[name] || PALETTES[DEFAULT_PALETTE]
  if (typeof document === 'undefined') return
  const root = document.documentElement
  for (const shade of Object.keys(palette.shades)) {
    root.style.setProperty(`--app-primary-${shade}`, palette.shades[shade])
  }
}

// Resolved "hsl(...)" string for a given shade. Use in places that don't
// flow through Tailwind classes (e.g. recharts stroke/fill attributes).
export function paletteHsl(name, shade) {
  const palette = PALETTES[name] || PALETTES[DEFAULT_PALETTE]
  return `hsl(${palette.shades[shade]})`
}
